import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedFlex,
  Heading,
  Body,
  Link,
  Tooltip,
  TooltipIcon,
} from '../../coreui';

import WatchlistItem from './WatchlistItem';

const Watchlist = ({
  tooltip,
  items,
}) => {
  if (!tooltip) {
    return null;
  }
  const length = items.length;
  return (
    <ExtendedFlex
      w={1}
      flexDirection="column"
      align="center"
      maxWidth={1700}
      px={50}
      mt={140}
    >
      <ExtendedFlex
        justifyContent="flex-start"
        align="center"
        width="92%"
        mx="auto"
      >
        <Heading
          type="H9"
          my={0}
          mr={10}
        >
          Watchlist
        </Heading>
        <TooltipIcon
          tooltipId="pendingWatchlistInvestmentsTooltip"
        />
        <Tooltip id="pendingWatchlistInvestmentsTooltip">
          <Body type="B5">
            {tooltip}
          </Body>
        </Tooltip>
      </ExtendedFlex>
      {
        length > 0 &&
        items.map((item) => (
          <WatchlistItem
            key={`watchlist:${item.id}`}
            item={item}
          />
        ))
      }
      {
        length === 0 &&
        <ExtendedFlex
          w="calc(92% - 30px)"
          flexDirection="column"
          align="flex-start"
        >
          <Body
            type="B1"
            mt={30}
            mb={50}
          >
            You have no watchlist items.
          </Body>
          <Link
            type="L1"
            to="/investment-opportunities"
          >
            Browse Opportunities
          </Link>
        </ExtendedFlex>
      }
    </ExtendedFlex>
  );
};

Watchlist.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  tooltip: PropTypes.node,
};

export default Watchlist;
